import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
// UI
import styles from './main.scss'
import { IntegrationToggle } from './IntegrationToggle'

export const Accordion = ({ title, children, onToggle, categoryId, active, language, disabledToggle }) => {
  const [expanded, setExpanded] = useState(false)

  const handleExpand = () => {
    setExpanded(!expanded)
  }

  const contentClass = cn(styles.content, { [styles.expanded]: expanded })
  const triangleClass = cn(styles.triangle, { [styles.expanded]: expanded })

  return (
    <div className={styles.wrapper}>
      <IntegrationToggle
        id={categoryId}
        text={title}
        onExpandClick={handleExpand}
        triangleClass={triangleClass}
        onToggle={onToggle}
        active={active}
        language={language}
        disabledToggle={disabledToggle}
      />
      <div className={contentClass}>{children}</div>
    </div>
  )
}

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.any,
  onToggle: PropTypes.func,
  categoryId: PropTypes.string,
  active: PropTypes.bool,
  disabledToggle: PropTypes.bool,
  language: PropTypes.oneOf(['de', 'en']),
}

Accordion.defaultProps = {
  language: 'de',
}
